export const environment = {
  apiURL: 'https://demo3.xeniosblockchaingroup.com',
  appVersion: require('../../package.json').version,
  background: 'background.png',
  logo: 'logo.png',
  name: 'CarsellFast Auction',
  production: false,
  sentryDSN: '',
  sentryEnvironment: '',
};
